import axios from "axios";
import HostService from "../../../services/host.service";
import AuthService from "../../../services/auth.service";

/**
 * Servicio para gestión de grupos N2
 */
class GruposService {
    /**
     * Crear un nuevo grupo de pedidos
     * @param {Object} data - Datos del grupo
     * @param {string} data.nombre - Nombre del grupo (opcional)
     * @param {Array} data.pedidos - Array de pedidos [{numero, tipo}]
     * @param {number} data.ejercicio - Año del ejercicio
     * @returns {Promise<Object>} Grupo creado con productos agrupados
     */
    static async create(data) {
        const response = await axios.post(
            HostService.getHost() + 'ventas/n2/grupos',
            data,
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Listar grupos activos (estado != 'completado')
     * @param {number} ejercicio - Año del ejercicio
     * @returns {Promise<Array>} Lista de grupos activos
     */
    static async list(ejercicio) {
        const response = await axios.get(
            HostService.getHost() + 'ventas/n2/grupos?ejercicio=' + ejercicio,
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Obtener grupo por ID
     * @param {number} id - ID del grupo
     * @param {number} ejercicio - Año del ejercicio
     * @returns {Promise<Object>} Grupo con productos y datos actuales
     */
    static async getById(id, ejercicio) {
        const response = await axios.get(
            HostService.getHost() + 'ventas/n2/grupos/' + id + '?ejercicio=' + ejercicio,
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Actualizar preparador del grupo
     * @param {number} id - ID del grupo
     * @param {string} preparador - Nombre del preparador
     * @returns {Promise<Object>} Grupo actualizado
     */
    static async updatePreparador(id, preparador) {
        const response = await axios.put(
            HostService.getHost() + 'ventas/n2/grupos/' + id + '/preparador',
            { preparador },
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Actualizar estado del grupo verificando pedidos
     * @param {number} id - ID del grupo
     * @param {number} ejercicio - Año del ejercicio
     * @param {string} [estado] - Estado a forzar: PENDIENTE | EN_PROCESO | COMPLETADO.
     *   Si se omite, el backend lo recalcula según el progreso de punteo
     * @returns {Promise<Object>} Grupo con estado actualizado
     */
    static async updateEstado(id, ejercicio, estado) {
        const response = await axios.put(
            HostService.getHost() + 'ventas/n2/grupos/' + id + '/estado',
            estado ? { ejercicio, estado } : { ejercicio },
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Eliminar grupo (solo si no tiene punteo)
     * @param {number} id - ID del grupo
     * @returns {Promise<void>}
     */
    static async delete(id) {
        const response = await axios.delete(
            HostService.getHost() + 'ventas/n2/grupos/' + id,
            AuthService.setToken()
        );
        return response.data;
    }
}

export default GruposService;
